import { render, staticRenderFns } from "./splitList.vue?vue&type=template&id=4564015f&scoped=true"
import script from "./splitList.vue?vue&type=script&lang=js"
export * from "./splitList.vue?vue&type=script&lang=js"
import style0 from "./splitList.vue?vue&type=style&index=0&id=4564015f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4564015f",
  null
  
)

export default component.exports